// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "us-east-1",
    "stage": "prod",
    "accountName": "peacock",
    "api_url": "https://wyykhzy0x0.execute-api.us-east-1.amazonaws.com/prod/graphql",
    "notifications_api_url": "https://wyykhzy0x0.execute-api.us-east-1.amazonaws.com/prod/notifications",
    "run_daily_test_url": "https://e0i36li4dd.execute-api.us-east-1.amazonaws.com/prod/run-daily-test",
    "sport_highlights_url": "https://26ubrmjx5fghrkrfmimw4slgke.appsync-api.us-east-1.amazonaws.com/graphql",
    "appconfig_url": "https://wyykhzy0x0.execute-api.us-east-1.amazonaws.com/prod/getConfig",
    "direct_appconfig_url": "https://x86vdjehj1.execute-api.us-east-1.amazonaws.com/prod/getConfig",
		"endpoint_url" : "https://wyykhzy0x0.execute-api.us-east-1.amazonaws.com/prod",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_J3SybEMdu",
    "aws_user_pools_web_client_id": "3j1509k0l0c4cr71j3a25droud",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.peacock.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.peacock.aidisco.sky.com",
        "responseType": "code"
    },
    "defaultChannelName": "ExternalSLE",
    "playfactoryLicenseAcquisitionEndpointUrl": "https://lfyovbl1j2.execute-api.us-east-1.amazonaws.com/prod",
    "arcusLicenseAcquisitionEndpointUrl": "https://c5hhg02165.execute-api.us-east-1.amazonaws.com/prod",
    "viperProxyUrl": ""
};

export default awsConfig;

